import styled, { css } from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
  text-align: initial;
  padding-bottom: 16px;
`;
Wrapper.displayName = 'Wrapper';

export const Content = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  
  ${(props) => props.disabled && css`
    pointer-events: none;
    opacity: 0.4;
  `}
`;

export const StyledCol = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 0;
  max-width: 264px;
  min-width: 264px;
`;

export const Title = styled.div`
  margin: 26px 26px 19px 0;
  font-size: 14.5px;
  font-weight: 500;
  line-height: 0.97;
  text-align: left;
  display: flex;
  width: 100%;
  color: ${({ theme }) => theme.text.modalTitle2};
  & input{
    margin-left: 25px;
  }
`;
Title.displayName = 'Title';

export const PasswordHint = styled.div`
  margin-bottom: 12px;
  font-size: 12.5px;
  line-height: 1.3;
  color: ${colors.grey17};
`;
PasswordHint.displayName = 'PasswordHint';

export const LockedWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 170px;
  border-radius: 4.1px;
  box-shadow: 3px 3px 7px 0 rgba(97, 97, 97, 0.07);
  border: solid 1.4px #dbdbdb;
  background-color: ${colors.paleGrey};
  margin-top: 15px;
  user-select: none;
`;
LockedWrapper.displayName = 'LockedWrapper';

export const FeatureImage = styled.img`
  flex: 0 0 200px;
  height: auto;
`;
FeatureImage.displayName = 'FeatureImage';

export const TextWrapper = styled.div`
  flex: 0 0 300px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
`;
TextWrapper.displayName = 'TextWrapper';

export const LockedDescription = styled.div`
  font-family: 'CentraNo2';
  font-weight: normal;
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  color: ${colors.grey19};
  text-align: center;
`;
LockedDescription.displayName = 'LockedDescription';

export const LockedLink = styled(LockedDescription)`
  margin-top: 30px;
  cursor: pointer;
  color: #0082ed;
`;
LockedLink.displayName = 'LockedLink';
